export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9342.a191f181.jpg";